import { Form } from "antd";
import { getConfigAppPartType } from "@lhd/features/Apps/utils";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { DATE_TIME_FORMAT } from "@lhd/constants";
import dayjs from "dayjs";
import { KeyboardEvent, useState } from "react";
import { Styles } from "./styled";
import { toDatePickerApiDate } from "@lhd/utility";
import { getRuleValidation } from "@lhd/components/CloneApp/fieldUtils";
import CommonDatePicker from "@lhd/components/CommonDatePicker";
import moment, { Moment } from "moment";

interface IProps {
  isDisabled?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
}

type DateTimeInputProps = {
  value?: string | null;
  onChange?: (value: string | null) => void;
  disabled?: boolean;
  styleColor?: React.CSSProperties;
  pickerKey: number;
  setPickerKey: React.Dispatch<React.SetStateAction<number>>;
};

const toApiDateTime = (raw: string | Moment | null | undefined) => {
  if (raw == null || raw === "") return null;
  if (moment.isMoment(raw)) {
    return raw.isValid()
      ? raw.format(DATE_TIME_FORMAT.DATE_TIME_DASH_SEC)
      : null;
  }
  const text = String(raw).trim();
  const withTime = moment(
    text,
    [
      DATE_TIME_FORMAT.DATE_TIME_DASH_SEC,
      DATE_TIME_FORMAT.DATE_TIME,
      DATE_TIME_FORMAT.DATE_JP_TIME,
      DATE_TIME_FORMAT.DATE_TIME_JP,
    ],
    true,
  );
  if (withTime.isValid()) {
    return withTime.format(DATE_TIME_FORMAT.DATE_TIME_DASH_SEC);
  }
  const api = toDatePickerApiDate(text);
  if (!api) return null;
  return moment(api, DATE_TIME_FORMAT.DATE_DASH, true).format(
    DATE_TIME_FORMAT.DATE_TIME_DASH_SEC,
  );
};

const CloneAppDateTimeInput = ({
  value,
  onChange,
  disabled,
  styleColor,
  pickerKey,
  setPickerKey,
}: DateTimeInputProps) => {
  const commit = (raw: string | Moment | null) => {
    if (raw == null || (typeof raw === "string" && !raw.trim())) {
      onChange?.(null);
      return;
    }
    const saved = toApiDateTime(raw);
    if (!saved) return;
    onChange?.(saved);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    event.stopPropagation();
    const input = event.currentTarget.querySelector("input");
    commit(input?.value ?? "");
  };

  const pickerValue = value && moment(value).isValid() ? moment(value) : null;

  return (
    <CommonDatePicker
      key={pickerKey}
      showTime={{ format: "HH:mm" }}
      displayFormat={DATE_TIME_FORMAT.DATE_JP_TIME}
      placeholder="日付を選択"
      disabled={disabled}
      allowClear
      style={styleColor}
      value={pickerValue}
      onKeyDown={handleKeyDown}
      onChange={(_saved, date) => commit(date)}
      onBlur={() => {
        setTimeout(() => setPickerKey((k) => k + 1), 300);
      }}
    />
  );
};

const DateAndTime = (props: IProps) => {
  const {
    item,
    isDisabled,
    style,
    nameItem,
    preview,
    isTable,
    styleColor = {},
  } = props;
  const { isHiddenLabel, labelText } = getConfigAppPartType(item);
  const form = Form.useFormInstance();
  const value = form.getFieldValue(nameItem);
  const isShowOnlyValue = !preview && isTable && isDisabled;
  const [pickerKey, setPickerKey] = useState(0);

  return (
    <Styles
      style={style}
      background={styleColor?.background}
      color={styleColor?.color}
    >
      <div className="value_text_container">
        {isShowOnlyValue &&
          value &&
          dayjs(value).format(DATE_TIME_FORMAT.DATE_JP_TIME)}
      </div>
      <Form.Item
        hidden={isShowOnlyValue}
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        name={nameItem}
        rules={getRuleValidation(item)}
        getValueProps={(fieldValue) => ({
          value: fieldValue || null,
        })}
      >
        <CloneAppDateTimeInput
          disabled={isDisabled}
          styleColor={styleColor}
          pickerKey={pickerKey}
          setPickerKey={setPickerKey}
        />
      </Form.Item>
    </Styles>
  );
};
export default DateAndTime;
